import {gsap} from "gsap"

import {ScrollTrigger} from "gsap/ScrollTrigger"
import {createIntersectionObserver} from "../../../js/intersection-observer/intersection-observer";

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

// Safari seems cant handle animations on scroll very well, its very laggy. So its turned off on Safari
if (!isSafari) {
  gsap.registerPlugin(ScrollTrigger)
}

const initReferences = () => {
  document.querySelectorAll<HTMLElement>(".i-reference:not(.--initialized)").forEach((reference) => {
    const expandButton = reference.querySelector(".i-reference__tags-expand")
    const closeButton = reference.querySelector(".i-reference__tags-close")

    const open = () => {
      reference.classList.add("--open-tags")
    }

    const close = () => {
      reference.classList.remove("--open-tags")
    }

    expandButton?.addEventListener("click", open)
    closeButton?.addEventListener("click", close)

    const image = reference.querySelector<HTMLElement>(".i-reference__image")
    image?.removeAttribute("style")

    const getMaxHeight = () => {
      return parseFloat(getComputedStyle(reference).getPropertyValue("--max-height").replace("rem", "")) * 16
    }
    const getDefaultHeight = () => {
      return parseFloat(getComputedStyle(reference).getPropertyValue("--height").replace("rem", "")) * 16
    }

    if (isSafari) {
      reference.classList.add("--open")
      if (image) image.style.height = getComputedStyle(reference).getPropertyValue("--max-height")

      return
    }

    gsap.to(image, {
      ease: "none",
      scrollTrigger: {
        trigger: reference,
        start: () => `${getDefaultHeight() + 32} 100%`,
        end: () => `+=${getMaxHeight() - getDefaultHeight()}`,
        scrub: true,
        invalidateOnRefresh: true,
        onLeave: () => {
          reference.classList.add("--open")
        },
        onEnterBack: () => {
          reference.classList.remove("--open")
        },
      },
      height: (i, el) => getComputedStyle(el).getPropertyValue("--max-height"),
    })

    reference.classList.add("--initialized")
  })
}

const referenceSection = document.querySelector<HTMLElement>('.s-references');

// Start observing the target element
createIntersectionObserver(referenceSection, initReferences);

document.addEventListener("referencesReinit", initReferences)
